import { Action } from 'redux';
import { HomeAddFavoriteSucceeded, HomeCloseWelcomeScreen, HomeFetchFavoritesSucceeded, HomeFetchPopularSucceeded, HomeFetchRecentsSucceeded, HomeFetchRecommendationsSucceeded, HomeRemoveFavoriteSucceeded } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';
import { ListResult } from '../../ts/fetchers/ListResult';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { FavoriteItemType } from '../../ts/ServerApi/types/IFavorite';

export interface HomeSucceededAction extends Action {
  readonly result: ListResult<IContentInfo>;
}

export interface HomeAddFavoriteSucceededInterface extends Action {
  contentId: string;
  contentType: FavoriteItemType;
}

export interface HomeRemoveFavoriteSucceededInterface extends Action {
  contentId: string;
  contentType: FavoriteItemType;
}

/*
 * action creators
 */

export function getHomeFetchFavoritesSucceededAction(result: ListResult<IContentInfo>): HomeSucceededAction {
  return {
    type: HomeFetchFavoritesSucceeded,
    result
  };
}

export function getHomeFetchRecentsSucceededAction(result: ListResult<IContentInfo>): HomeSucceededAction {
  return {
    type: HomeFetchRecentsSucceeded,
    result
  };
}

export function getHomeFetchPopularSucceededAction(result: ListResult<IContentInfo>): HomeSucceededAction {
  return {
    type: HomeFetchPopularSucceeded,
    result
  };
}

export function getHomeFetchRecommendationsSucceededAction(result: ListResult<IContentInfo>): HomeSucceededAction {
  return {
    type: HomeFetchRecommendationsSucceeded,
    result
  };
}

export function getHomeAddFavoriteSucceededAction(contentId: string, contentType: FavoriteItemType): HomeAddFavoriteSucceededInterface {
  return {
    type: HomeAddFavoriteSucceeded,
    contentId,
    contentType
  };
}

export function getHomeRemoveFavoriteSucceededAction(contentId: string, contentType: FavoriteItemType): HomeRemoveFavoriteSucceededInterface {
  return {
    type: HomeRemoveFavoriteSucceeded,
    contentId,
    contentType
  };
}

export const ishomeFetchFavoritesSucceededAction = isActionFactory<HomeSucceededAction>(HomeFetchFavoritesSucceeded);
export const ishomeFetchRecentsSucceededAction = isActionFactory<HomeSucceededAction>(HomeFetchRecentsSucceeded);
export const ishomeFetchPopularSucceededAction = isActionFactory<HomeSucceededAction>(HomeFetchPopularSucceeded);
export const ishomeFetchRecommendationsSucceededAction = isActionFactory<HomeSucceededAction>(HomeFetchRecommendationsSucceeded);
export const isHomeAddFavoriteSucceededAction = isActionFactory<HomeAddFavoriteSucceededInterface>(HomeAddFavoriteSucceeded);
export const isHomeRemoveFavoriteSucceededAction = isActionFactory<HomeRemoveFavoriteSucceededInterface>(HomeRemoveFavoriteSucceeded);
export const isCloseWelcomeScreenAction = isActionFactory<Action>(HomeCloseWelcomeScreen);

export function homeCloseWelcomeScreenAction() {
  return {
    type: HomeCloseWelcomeScreen,
  };
}
